import React from "react";
import Layout from "./Layout";
import RyanPhoto from "./assets/ryan-profile.png"; // adjust path if needed

const About = () => {
  return (
    <Layout>
      <div style={styles.container}>
        <h1 style={styles.heading}>About Ryan's Tutoring</h1>
        <p style={styles.subheading}>
          Empowering students in <strong>Maths</strong> and <strong>French</strong> through expert, friendly online tuition.
        </p>

        <div style={styles.contentBox}>
        <div style={styles.profileSection}>
  <img src={RyanPhoto} alt="Ryan - your tutor" style={styles.profileImage} />
</div>

          <h2 style={styles.sectionTitle}>👨‍🏫 Meet Your Tutor</h2>
          <p style={styles.text}>
            Hi! I’m Ryan — an experienced and enthusiastic tutor with a passion for helping students achieve their full potential. I specialise in Maths and French and support learners from Key Stage 2 up to A-Level through tailored <strong>online lessons</strong> that are engaging and effective.
          </p>

          <h2 style={styles.sectionTitle}>💻 Why Online?</h2>
          <p style={styles.text}>
            All sessions are delivered online, making them convenient, flexible, and accessible from the comfort of your own home. I use interactive tools and a structured approach to keep lessons focused, productive and enjoyable.
          </p>

          <h2 style={styles.sectionTitle}>🎯 What I Offer</h2>
          <ul style={styles.list}>
            <li>Personalised 1-to-1 online tutoring sessions</li>
            <li>Support with schoolwork, exam preparation and confidence building</li>
            <li>Specialised resources tailored to each student’s needs</li>
          </ul>

          <h2 style={styles.sectionTitle}>💷 Pricing</h2>
          <ul style={styles.list}>
            <li><strong>GCSE:</strong> £30 per hour session</li>
            <li><strong>A-Level:</strong> £40 per 1.5-hour session</li>
            <li><strong>First lesson is 50% off</strong> — a great way to see if it's the right fit!</li>
          </ul>

          <h2 style={styles.sectionTitle}>🤝 My Approach</h2>
          <p style={styles.text}>
            Every student learns differently. I take the time to understand how you learn best, and adapt each lesson to suit your goals. Whether you're catching up, keeping up or aiming to excel, I’ll help you take the next step with confidence.
          </p>
        </div>
      </div>
    </Layout>
  );
};

const styles = {
  container: {
    padding: "40px 20px",
    backgroundColor: "#e6f0ff",
    minHeight: "100vh",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  heading: {
    textAlign: "center",
    fontSize: "36px",
    marginBottom: "10px",
    color: "#003366",
  },
  subheading: {
    textAlign: "center",
    fontSize: "18px",
    color: "#333",
    marginBottom: "40px",
  },
  contentBox: {
    maxWidth: "800px",
    margin: "0 auto",
    backgroundColor: "#ffffff",
    padding: "30px",
    borderRadius: "10px",
    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  },
  sectionTitle: {
    fontSize: "24px",
    marginTop: "20px",
    color: "#004080",
  },
  text: {
    fontSize: "16px",
    lineHeight: "1.6",
    color: "#444",
  },
  list: {
    fontSize: "16px",
    paddingLeft: "20px",
    lineHeight: "1.8",
    color: "#444",
  },
  profileSection: {
    textAlign: "center",
    marginBottom: "20px",
  },
  
  profileImage: {
    width: "160px",
    height: "160px",
    borderRadius: "50%",
    objectFit: "cover",
    border: "3px solid #004080",
    boxShadow: "0 4px 10px rgba(0,0,0,0.1)",
  },
  
};

export default About;
